<template>
  <div>
    <Teleport to="#settings-group-header">
      <T>Зоны доставки</T>
    </Teleport>  

    <Teleport to="#settings-group-actions">
      <v-btn test-tag="tag-265"
        text
        color="primary"
        @click="save"
        :loading="loading"
        :disabled="loading"
      >
        <v-icon>mdi-content-save</v-icon>
        <T>Сохранить</T>
      </v-btn>
    </Teleport>

    <DeliveryZones :loading="loading" ref="form" :config="this.$store.getters.local_refs" />
  </div>
</template>

<script>
import Teleport from 'vue2-teleport'
import DeliveryZones from '../../components/settings/delivery_zones'


export default {
  data: () => ({
    loading: false
  }),
  methods: {
    async save(){
      this.loading = true
      try {
        let new_config = {geocoding: this.$refs.form.submit().geocoding}
        
        await this.$store.dispatch('updateLocalRefs', new_config)

        this.$store.dispatch('throwTimeoutMessage', {
          message_data: this.$t('Изменения сохранены'),
          message_class: 'success'
        })

      } catch (e) {
        this.$store.dispatch('throwTimeoutMessage', {
          message_data: `${e.message}`,
          message_class: 'error'
        })
        this.loading = false
      } finally {
        this.loading = false
      }
    }
  },
  components: {
    Teleport,
    DeliveryZones
  }
}
</script>